import React, { Component } from 'react';
import { Big3Common, bootstrap } from '../../../js/IncludeManager'
import { Alert } from '../../../js/ComponentManager'
/* 개발담당:양유빈
 * 화면기능:라이브챗 주문서
 * 세부설명:
*/
export class LiveChatGoods extends Component {
    static displayName = LiveChatGoods.name;

    constructor(props) {
        super(props);
        this.state = {
            SearchText: "",
            SelectGoods_No: 0,
            ChatGoodsList: []
        };

        this.handle_KeyDown = this.handle_KeyDown.bind(this);
        this.handleSearch_Blur = this.handleSearch_Blur.bind(this);
        this.handleSelectGoods_Click = this.handleSelectGoods_Click.bind(this);
        this.handleSend_Click = this.handleSend_Click.bind(this);
        this.handleSearch_Click = this.handleSearch_Click.bind(this);

        this.CsName = Big3Common.ContentState;
        this.Union_Uid = "";
        if (this.props.ContentState !== undefined) {
            this.Union_Uid = this.props.ContentState[this.CsName.Union_Uid] !== undefined ? this.props.ContentState[this.CsName.Union_Uid] : "";
        }
    }
    //초기화
    componentDidMount() {
        this.CallLiveChatGoodsData("");
    }
    //주문문의 조회
    async CallLiveChatGoodsData(Goods_nm) {
        try {
            Big3Common.Util.LoadingOn();
            let Data = await Big3Common.Post('api/Order/LiveChat/GetSearchGoodsList', {
                union_uid: this.Union_Uid,
                goods_nm: Goods_nm
            });
            if (Data.codeName === Big3Common.ResultCode.Success) {
                let ChatGoodsList = JSON.parse(Data.dataTable);
                this.setState({
                    ChatGoodsList: ChatGoodsList
                });
            }
            else {
                console.log(Data.message);
            }
        }
        catch (e) {
            console.log("CallLiveChatGoodsData: ", e)
        }
        finally {
            Big3Common.Util.LoadingOff();
        }
        return false;
    }
    handle_KeyDown(event) {
        if (event.key === 'Enter') {
            const value = event.target.value;
            this.CallLiveChatGoodsData(value);
        }
        return false;
    }
    //검색 TextBox
    handleSearch_Blur(event) {
        const value = event.target.value;
        this.setState({ SearchText: value });
        event.preventDefault();
    }
    //검색
    handleSearch_Click = (event) => {
        this.CallLiveChatGoodsData(this.state.SearchText);
        event.preventDefault();
    }
    //상품선택
    handleSelectGoods_Click = (event, Goods_No) => {
        this.setState({ SelectGoods_No: Goods_No });
        event.preventDefault();
    }
    //선택상품 전송
    handleSend_Click = (event) => {
        if (this.state.SelectGoods_No === 0) {
            Big3Common.ModalAlert(bootstrap, 'LiveChatGoodsAlert');
            return false;
        }
        const ContentState = this.props.ContentState;
        ContentState.SelectGoods_No = this.state.SelectGoods_No;
        this.props.RenderComponent("LiveChatDig", ContentState);
        event.preventDefault();
    }
    Listrender() {
        const ChatGoodsList = this.state.ChatGoodsList;
        const VirtualRoot = Big3Common.WebConfig.GoodsImageVirtualPath();
        return (
            <>
                {ChatGoodsList.map((list, idx) =>
                    <div className="col" key={idx} onClick={(e) => { this.handleSelectGoods_Click(e, list.goods_no) }}>
                        <div className="goods_img"
                            style={{ backgroundImage: `url(${VirtualRoot}${list.img_220})` }}
                        >
                            {list.goods_no === this.state.SelectGoods_No ? <div className="p_select"><p></p></div> : ""}
                        </div>
                        <div className="goods_title">{list.goods_nm}</div>
                        <div className="goods_price">{Big3Common.Util.Money(list.goods_price) }원</div>
                        <div className="goods_views">{list.view_cnt }건</div>
                    </div>
                )}
            </>
        )
    }
    render() {
        let Listrender = this.Listrender();
        return (
            <>
                <div className="container_box p_margin u_padding">
                    <div className="search_box  retail_search">
                        <div className="search_input_box">
                            <input type="search" placeholder="상품명을 입력해주세요."
                                className="form-control"
                                value={this.state.SearchText}
                                onKeyDown={this.handle_KeyDown}
                                onChange={(e) => { this.handleSearch_Blur(e); }}
                                onBlur={(e) => { this.handleSearch_Blur(e); }}
                            />
                            <div className="search_btn" onClick={(e) => { this.handleSearch_Click(e) } }></div>
                        </div>
                    </div>
                    <div className="goods_list row row-cols-3">
                        {Listrender}
                    </div>

                </div>
                <div className="p_send_btn_box" onClick={(e) => { this.handleSend_Click(e) }}>
                    <div>선택전송</div>
                    <p></p>
                </div>
                <Alert
                    id="LiveChatGoodsAlert"
                    content=""
                    title="상품을 선택하세요."
                />
            </>
        );
    }
}
